// Plugin made from:
// http://stackoverflow.com/questions/5802467/prevent-scrolling-of-parent-element

$.fn.scrollLock = function () {
    return $(this).on("DOMMouseScroll mousewheel", function (h) {
        var g = $(this),
            s = h.shiftKey,
            f = (s ? this.scrollLeft : this.scrollTop),
            d = (s ? this.scrollWidth : this.scrollHeight),
            b = (s ? g.width() : g.height()),
            i = h.originalEvent.wheelDelta,
            a = i > 0,
            c = function () {
                h.stopPropagation();
                h.preventDefault();
                h.returnValue = false;
                return false
            };

         if (!a && -i > d - b - f) {
             if (s) {
                 g.scrollLeft(d);
             } else {
                 g.scrollTop(d);
             }
             return c()
         } else {
             if (a && i > f) {
                 if (s) {
                     g.scrollLeft(0);
                 } else {
                     g.scrollTop(0);
                 }
                 return c()
            }
        }
    });
}

$.fn.scrollRelease = function () {
    return $(this).off("DOMMouseScroll mousewheel")
}
